import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../icon/icon.component';
import { identity, getScreenSize } from '../utils/sizes';
import {
  defaultContext,
  getInitialStyle,
  getFocusedStyle,
  getUnFocusedStyle,
  ICON_WIDTH,
  ICON_HEIGHT,
  PADDING,
  ICON_PADDING_LEFT,
} from './button.style';
import { ButtonBackground } from '../callToAction/background/buttonBackground.component';

/**
 * Component providing a possibility for a user to interact with the app. Could contain icon and/or text label.
 */
export class Button extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          type: ButtonBackground,
          w: identity,
        },
        Fill: {},
        Icon: {
          type: Icon,
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._isIconTxLoading = false;
    this._isLabelTxLoading = false;
    this._minWidth = 0;
  }

  _init() {
    const label = this.tag('Label');
    const icon = this.tag('Icon');

    const screenSize = getScreenSize();
    const iconWidth = ICON_WIDTH[screenSize];
    const iconPaddingLeft = ICON_PADDING_LEFT[screenSize];
    const padding = PADDING[screenSize];

    const handleUpdate = () => {
      if (this._isIconTxLoading || this._isLabelTxLoading) {
        return;
      }

      const size = padding * 2 + label.finalW;
      const offset = icon.finalW ? iconPaddingLeft + iconWidth : 0;
      const w = Math.max(size + offset, this._minWidth);

      this.patch({
        w,
        Icon: {
          x: padding,
        },
        Label: {
          x: Math.max(padding + offset, Math.round((w - label.finalW) / 2)),
        },
      });
    };

    icon.on('txLoaded', () => {
      this._isIconTxLoading = false;
      handleUpdate();
    });
    label.on('txLoaded', () => {
      this._isLabelTxLoading = false;
      handleUpdate();
    });
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  set label(value) {
    this.tag('Label').text.text = value;
    this._isLabelTxLoading = true;
  }

  set picto(value) {
    this._isIconTxLoading = true;
    const screenSize = getScreenSize();

    this.tag('Icon').iconData = {
      picto: value,
      viewBox: {
        w: ICON_WIDTH[screenSize],
        h: ICON_HEIGHT[screenSize],
      },
    };
  }

  get colorMode() {
    return this._style.colorMode;
  }

  set colorMode(value) {
    this._style = { ...this._style, colorMode: value };
    this.patch(getInitialStyle(this._style));
  }

  get minWidth() {
    return this._minWidth;
  }

  set minWidth(value) {
    this._minWidth = value;
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(getUnFocusedStyle(this._style));
  }
}
